import { gql } from 'graphql-request';

export const UPDATE_POA_DRAFT = gql`
  mutation UpdatePoaDraft($input: core_POAMutationNS_updateDraftInputInput) {
    corePOA {
      updateDraft(input: $input)
    }
  }
`;
